<div class="ps-flex-container-col" style="padding: 12px">
  <h3>{{'contacts.createContact.createContact' | translate}}</h3>

  <mat-form-field>
    <mat-label>{{'contacts.createContact.firstName' | translate}}</mat-label>
    <input matInput [(ngModel)]="contact.firstName">
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'contacts.createContact.lastName' | translate}}</mat-label>
    <input matInput [(ngModel)]="contact.lastName">
  </mat-form-field>
  <div style="display: flex; justify-content: end">
    <button mat-button color="accent" matTooltip="{{'contacts.createContact.discard' | translate}}" (click)="dismiss()">
      VERWERFEN
    </button>
    <button mat-button color="accent" matTooltip="{{'contacts.createContact.saveContact' | translate}}"
            (click)="save()">
      {{'contacts.createContact.save' | translate}}
    </button>
  </div>
</div>
